import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OfficeDoorStatusDTO } from 'src/app/shared/dto/domotica/officeDoorStatus';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DomoticaService {
  private url: String;

  constructor(private http: HttpClient) {
    this.url = environment.urlPrefix + '/services/rest/json/domotica';
  }

  public officeDoorStatus(avoidCache?: boolean): Observable<OfficeDoorStatusDTO> {
    let params = {};
    if (avoidCache != null) params["avoidCache"] = avoidCache;

    return this.http.get<OfficeDoorStatusDTO>(`${this.url}/officeDoor/status`, {
      params: params
    });
  }

  public officeDoorCommand(command: string): Observable<void> {
    return this.http.get<void>(`${this.url}/officeDoor/command/${command}`);
  }

  public officeDoorCommandWithLocation(command: string, qrcode: string): Observable<void> {
    return this.http.get<void>(`${this.url}/officeDoor/command/${command}/${qrcode}`);
  }

  public canUnlockOfficeDoor(officeDoorStatus: OfficeDoorStatusDTO): boolean {
    return officeDoorStatus.availableCommands.some(c => c === this.unlockCommand);
  }

  public downstairsDoorCommand(): Observable<void> {
    return this.http.get<void>(`${this.url}/downstairsDoor`);
  }

  public get unlockCommand(): string {
    return 'UNLOCK';
  }

}